import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useUserContext } from 'providers/UserProvider';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

const WarehouseDropdown = () => {
  const { user, selectedWarehouse, isLoading, warehouse_permissions } =
    useUserContext();
  const navigate = useNavigate();
  const location = useLocation();

  const { tenant, warehouse } = useParams();

  const warehouseList = warehouse_permissions?.map(wp => wp.warehouse) || [];

  const onWarehouseChange = newWarehouse => {
    if (!tenant || !warehouse) return;

    const newPath = location.pathname.replace(
      new RegExp(`^/${tenant}/${warehouse}(?=/|$)`),
      `/${tenant}/${encodeURIComponent(newWarehouse.domain)}`,
    );

    navigate({
      pathname: newPath,
      search: location.search,
      hash: location.hash,
    });
  };

  const handleDropdownToggle = isOpen => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
  };

  if (isLoading) {
    return (
      <div className="px-3 d-flex align-items-center">
        <div
          className="spinner-border spinner-border-sm text-primary"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Dropdown onToggle={handleDropdownToggle}>
      <Dropdown.Toggle
        variant="falcon-default"
        className="text-truncate"
        style={{ maxWidth: '200px' }}
      >
        {selectedWarehouse ? (
          selectedWarehouse.name
        ) : (
          <span className="text-muted">Loading...</span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-menu-end" style={{ width: '200px' }}>
        {warehouseList.length === 0 && (
          <Dropdown.Item disabled className="text-muted">
            No warehouses
          </Dropdown.Item>
        )}
        {warehouseList.map(w => (
          <Dropdown.Item
            key={w.id}
            onClick={() => onWarehouseChange(w)}
            active={selectedWarehouse?.id === w.id}
            className="text-truncate"
          >
            {w.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default WarehouseDropdown;
